import { Resource, ResourceType } from '../pages/request/types';

type ResourceTemplateConfig = {
  templateRef: string;
  getValues: (r: Resource) => Record<string, any>;
  fields: {
    name: string;
    label: string;
    external?: boolean;
    multiline?: boolean;
    options?: { value: string; label: string }[];
    multiple?: boolean;
  }[];
};

export const resourceTypeMapper: Record<keyof typeof ResourceType, ResourceTemplateConfig> = {
  'gcp-sql-instance': {
    templateRef: 'default/resource-create-gcp-instance',
    getValues: (r) => ({
      system: r.system,
      environment: r.environment,
    }),
    fields: [
      { name: 'system', label: 'System', external: true },
      { name: 'environment', label: 'Environment', multiple: true, options: [ { value: 'dev', label: 'Development' }, { value: 'stg', label: 'Staging' }, { value: 'prd', label: 'Production' }, ] },
    ],
  },
  'gcp-sql-database': {
    templateRef: 'default/resource-create-gcp-database',
    getValues: (r) => ({
      system: r.system,
      name: r.name,
      title: r.title,
      description: r.description,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'gcp-maps-api': {
    templateRef: 'default/resource-create-gcp-maps-api',
    getValues: (r) => ({
      system: r.system,
      environment: r.environment,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'gcp-storage-bucket': {
    templateRef: 'default/resource-create-gcp-storage-bucket',
    getValues: (r) => ({
      system: r.system,
      environment: r.environment,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'gcp-secret-manager': {
    templateRef: 'default/resource-create-gcp-secret-manager',
    getValues: (r) => ({
      system: r.system,
      name: r.name,
      title: r.title,
      description: r.description,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'totvs-rac': {
    templateRef: 'default/resource-create-totvs-rac',
    getValues: (r) => ({
      system: r.system,
      name: r.name,
      title: r.title,
      description: r.description,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'totvs-identity': {
    templateRef: 'default/resource-create-totvs-identity',
    getValues: (r) => ({
      system: r.system,
      name: r.name,
      title: r.title,
      description: r.description,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'totvs-smart-talk': {
    templateRef: 'default/resource-create-totvs-smart-talk',
    getValues: (r) => ({
      system: r.system,
      name: r.name,
      title: r.title,
      description: r.description,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
  'totvs-tpd': {
    templateRef: 'default/resource-create-totvs-tpd',
    getValues: (r) => ({
      system: r.system,
      name: r.name,
      title: r.title,
      description: r.description,
    }),
    fields: [
      { name: 'system', label: 'System' },
    ],
  },
};
